import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { PawVerseLogo, PawVerseWordmark } from './PawVerseLogo';
const navLinks = [{
  name: 'Home',
  path: '/'
}, {
  name: 'Programs',
  path: '/programs'
}, {
  name: 'Workshops',
  path: '/workshops'
}, {
  name: 'Resources',
  path: '/resources'
}, {
  name: 'About',
  path: '/about'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);
  return <header className={`${`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-warm-white/90 backdrop-blur-md shadow-warm-sm py-3' : 'bg-transparent py-5'}`} bg-[#FAF6E8]`} data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="flex justify-between items-center" data-id="element-109">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 group" aria-label="PawVerse Home" data-id="element-110">
            <PawVerseLogo size={38} className="group-hover:scale-105 transition-transform" data-id="element-111" />
            <PawVerseWordmark variant="light" className="text-2xl" data-id="element-112" />
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center gap-6" data-id="element-113">
            {navLinks.map(link => <Link key={link.path} to={link.path} className={`font-body text-sm font-medium transition-colors hover:text-accent-500 ${location.pathname === link.path ? 'text-accent-500' : 'text-warm-gray-700'}`} data-id="element-114">
                {link.name}
              </Link>)}
          </nav>

          {/* CTA & Mobile Toggle */}
          <div className="flex items-center gap-4" data-id="element-115">
            <Link to="/resources" className="hidden md:inline-flex items-center justify-center px-6 py-2.5 border border-transparent text-sm font-medium rounded-full text-warm-white bg-primary-800 hover:bg-primary-700 shadow-warm transition-all hover:-translate-y-0.5" data-id="element-116">
              Get Started Free
            </Link>

            <button type="button" className="lg:hidden p-2 text-primary-900 hover:bg-warm-gray-100 rounded-md transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-expanded={isMobileMenuOpen} aria-label="Toggle navigation menu" data-id="element-117">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-118" /> : <Menu className="w-6 h-6" data-id="element-119" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-120">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-warm-white border-b border-warm-gray-200 overflow-hidden shadow-warm-lg" data-id="element-121">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-122">
              {navLinks.map(link => <Link key={link.path} to={link.path} className={`block px-3 py-3 rounded-md font-body text-base font-medium ${location.pathname === link.path ? 'bg-primary-50 text-primary-800' : 'text-warm-gray-700 hover:bg-warm-gray-50 hover:text-primary-800'}`} data-id="element-123">
                  {link.name}
                </Link>)}
              <div className="pt-4 pb-2" data-id="element-124">
                <Link to="/resources" className="block w-full text-center px-6 py-3 border border-transparent text-base font-medium rounded-full text-warm-white bg-primary-800 hover:bg-primary-700 shadow-warm" data-id="element-125">
                  Get Started Free
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}